import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    // A client who just accepted a project invite opens that project on their
    // first sign-in (SetUpProfile stores its id; Layout clears it once used).
    let joinProject = null;
    try {
      joinProject = localStorage.getItem("qh_join_project");
    } catch {}
    const target =
      joinProject && /^[a-f0-9]{24}$/i.test(joinProject)
        ? `/dashboard/projects/${joinProject}`
        : "/dashboard";
    return <Navigate to={target} replace />;
  }

  return children;
};

export default PublicRoute;
